import React from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import css from './rank-tiles.scss';
import Tile from './tile';

const RankTiles = (data) => {
    const rankList = Object.entries(data.newCertificateSummary);
    const tiles = rankList.map((rank) => {
        const key = rank[0];
        const value = rank[1];
        return (
            <div key={key}>
                <Tile total={value} rank={key} />
            </div>
        );
    });

    return (
        <div className={css['rank-tiles']}>
            {tiles}
        </div>
    );
};

RankTiles.propType = {
    newCertificateSummary: PropTypes.object
};

export default styleable(css)(RankTiles);




// WEBPACK FOOTER //
// ./containers/participation-report/sub-components/rank-tiles.js